import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { handleActivateSite } from "./SiteAboutPageUtils/handleActivateSite";
import { useNavigate } from "react-router-dom";
import {
  AlertState,
  SiteInfo,
  PatchObject,
} from "./SiteAboutPageUtils/siteAboutInterfaces";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const ActivateSiteWithScheduleDialog = ({
  activateSiteWithScheduleDialogOpen,
  setActivateSiteWithScheduleDialogOpen,
  setSiteInfo,
  setBackdropLoadingScreenOn,
  setAlertState,
  setPatchObject,
  patchObject,
  setSiteSchedules,
  setAllSiteSchedules,
  clickedTab,
  setActiveTab,
  setDeleteScheduleDialogOpen,
  siteInfo,
}: {
  activateSiteWithScheduleDialogOpen: boolean;
  setActivateSiteWithScheduleDialogOpen: Dispatcher<boolean>;
  setSiteInfo: Dispatcher<SiteInfo>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setAlertState: Dispatcher<AlertState>;
  setPatchObject: Dispatcher<PatchObject>;
  patchObject: PatchObject;
  setSiteSchedules: Dispatcher<any>;
  setAllSiteSchedules: Dispatcher<any>;
  clickedTab: any;
  setActiveTab: any;
  setDeleteScheduleDialogOpen: any;
  siteInfo: SiteInfo;
}) => {
  const navigate = useNavigate();
  return (
    <Dialog open={activateSiteWithScheduleDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        {
          "You have added a schedule to a site which isn't active. Schedules will not run until the site is activated. Would you like to activate this site?"
        }
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setSiteInfo((previousState: SiteInfo) => {
              return { ...previousState, active: false };
            });
            setActivateSiteWithScheduleDialogOpen(false);
          }}
          text="No"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setActivateSiteWithScheduleDialogOpen(false);
            setPatchObject((previousState: PatchObject) => {
              return {
                ...previousState,
                active: true,
              };
            });
            setSiteInfo((previousState: SiteInfo) => {
              return {
                ...previousState,
                active: true,
              };
            });
            handleActivateSite(
              setBackdropLoadingScreenOn,
              patchObject,
              setSiteInfo,
              setAlertState,
              setPatchObject,
              siteInfo,
              setSiteSchedules,
              setAllSiteSchedules,
              clickedTab,
              setActiveTab,
              setDeleteScheduleDialogOpen,
              navigate
            );
          }}
          text="Yes, Activate"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
